export default "__VITE_ASSET__CZnuni8W__"